var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 28,
    viewBox: "0 0 45 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 3.73333H28.125V0H41.25V3.73333ZM44.4375 22.4C43.6875 24.8267 40.6875 28 34.875 28C29.0625 28 24.375 24.8267 24.375 17.36C24.375 10.08 28.6875 6.34667 34.6875 6.34667C40.5 6.34667 44.0625 9.70667 44.8125 14.56C45 15.4933 45 16.8 45 18.6667H30C30.1875 24.64 36.5625 24.8267 38.625 22.4H44.4375ZM30 14.9333H39.375C39.1875 12.1333 37.3125 10.8267 34.6875 10.8267C32.0625 10.8267 30.5625 12.1333 30 14.9333ZM12.1875 28H0V0H13.125C23.4375 0.186667 23.625 10.08 18.1875 12.88C24.5625 15.3067 24.75 28 12.1875 28ZM5.625 11.2H12.375C17.0625 11.2 17.8125 5.6 11.8125 5.6H5.625V11.2ZM12 16.8H5.625V22.4H11.8125C17.625 22.4 17.25 16.8 12 16.8Z",
    fill: "#F4F1DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/Behance.1f399d7fff75eeadaebb2bcc84309b4d.svg";
export { ForwardRef as ReactComponent };